import {
  Shield,
  CheckCircle,
  Activity,
  ThumbsUp,
  ThumbsDown,
  MessageSquare
} from 'lucide-react';
import { McButton } from '@maersk-global/mds-react-wrapper/components-core/mc-button';

export function ChangeReportCardModal({ selectedChange, onClose, getRiskColor }) {
  if (!selectedChange) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div>
            <h2 className="modal-title">Change Report Card</h2>
            <p className="modal-subtitle">
              {selectedChange.changeId}
            </p>
          </div>
          <button
            onClick={onClose}
            className="modal-close"
          >
            <span>×</span>
          </button>
        </div>

        <div className="modal-grid">
          <div className="modal-section">
            <h4 className="modal-section-title">Change Summary</h4>
            <div className="modal-field">
              <span className="modal-field-label">Application</span>
              <p className="modal-field-value">
                {selectedChange.application}
              </p>
            </div>
            <div className="modal-field">
              <span className="modal-field-label">Description</span>
              <p className="modal-field-value">
                {selectedChange.description}
              </p>
            </div>
            <div className="modal-field">
              <span className="modal-field-label">Environment</span>
              <p className="modal-field-value">
                {selectedChange.environment}
              </p>
            </div>
          </div>

          <div className="modal-section">
            <h4 className="modal-section-title">Risk Assessment</h4>
            <div className="modal-field">
              <div className="modal-field">
                <span className="modal-field-label">Risk Level</span>
                <span className={getRiskColor(selectedChange.riskLevel)}>
                  {selectedChange.riskLevel}
                </span>
              </div>
            </div>
            <div className="modal-field">
              <div className="modal-field">
                <span className="modal-field-label">Risk Score</span>
                <span className="modal-field-value">
                  {selectedChange.riskLevel === 'Emergency' ? '95' : selectedChange.riskLevel === 'High' ? '78' : selectedChange.riskLevel === 'Medium' ? '45' : '20'}/100
                </span>
              </div>
              <div className="progress-bar">
                <div
                  className="progress-bar-fill"
                  style={{
                    width: `${selectedChange.riskLevel === 'Emergency' ? '95' : selectedChange.riskLevel === 'High' ? '78' : selectedChange.riskLevel === 'Medium' ? '45' : '20'}%`,
                    backgroundColor: selectedChange.riskLevel === 'Emergency' || selectedChange.riskLevel === 'High' ? '#EF4444' : selectedChange.riskLevel === 'Medium' ? '#F59E0B' : '#10B981'
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="modal-stats-grid">
          <div className="modal-stat-card">
            <div className="modal-stat-header">
              <Shield style={{ width: '1.25rem', height: '1.25rem', color: '#10B981' }} />
              <span className="modal-stat-label">Compliance Score</span>
            </div>
            <p className="modal-stat-value">
              92%
            </p>
          </div>
          <div className="modal-stat-card">
            <div className="modal-stat-header">
              <CheckCircle style={{ width: '1.25rem', height: '1.25rem', color: '#3B82F6' }} />
              <span className="modal-stat-label">Test Coverage</span>
            </div>
            <p className="modal-stat-value">
              87%
            </p>
          </div>
          <div className="modal-stat-card">
            <div className="modal-stat-header">
              <Activity style={{ width: '1.25rem', height: '1.25rem', color: '#F59E0B' }} />
              <span className="modal-stat-label">Approvals</span>
            </div>
            <p className="modal-stat-value">
              2/3
            </p>
          </div>
        </div>

        <div className="modal-actions">
          <McButton variant="primary" className="btn-flex-1">
            <ThumbsUp style={{ width: '1rem', height: '1rem' }} />
            Approve Change
          </McButton>
          <McButton variant="destructive" className="btn-flex-1">
            <ThumbsDown style={{ width: '1rem', height: '1rem' }} />
            Reject Change
          </McButton>
          <McButton variant="outline">
            <MessageSquare style={{ width: '1rem', height: '1rem' }} />
            Request Info
          </McButton>
        </div>
      </div>
    </div>
  );
}
